export enum SysActionTypes {
  SYS_PUSH_INFO = "SYS_PUSH_INFO",
  SYS_INIT = "SYS_INIT",
  SYS_ADD_EQUIP = "SYS_ADD_EQUIP",
  SYS_GET_EQUIP = "SYS_GET_EQUIP",
  SYS_DEL_EQUIP = "SYS_DEL_EQUIP",
  SYS_GET_VERSION = "SYS_GET_VERSION",
  SYS_SET_WS = "SYS_SET_WS",
  SYS_WS_SEND = "SYS_WS_SEND"
}
